var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "allocation_box" }, [
    _c("div", { staticClass: "allocation_name" }, [_vm._v("等级配置")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "allocation_head", staticStyle: { "margin-top": "20px" } },
      [
        _c(
          "el-button",
          {
            staticStyle: { background: "#02c58d", border: "none" },
            attrs: { type: "primary", icon: "el-icon-plus" },
            on: { click: _vm.onAddAllocation },
          },
          [_vm._v("添加")]
        ),
        _vm._v(" "),
        _c("img", {
          staticStyle: { width: "16px", height: "16px", "margin-left": "10px" },
          attrs: { src: require("@/assets/icon/mark.png"), alt: "" },
        }),
        _vm._v(" "),
        _vm._m(0),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "my_table_name", staticStyle: { "margin-top": "20px" } },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              "header-row-class-name": "tab_box",
              data: _vm.tableData,
              "row-key": "name",
              border: "",
              "highlight-current-row": true,
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "name",
                label: "等级名称",
                align: "center",
                height: "40",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "grade",
                label: "等级权重",
                align: "center",
                height: "40",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "icon",
                label: "等级图标",
                align: "center",
                height: "40",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("img", {
                        staticStyle: { width: "60px", height: "25px" },
                        attrs: { src: scope.row.icon, alt: "" },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "",
                label: "升级权限",
                align: "center",
                height: "40",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.selfUpgrade === 0
                        ? _c("div", [_vm._v("禁止用户自动升级")])
                        : _vm._e(),
                      _vm._v(" "),
                      scope.row.selfUpgrade === 1
                        ? _c("div", [_vm._v("允许用户自动升级")])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "selfRate",
                label: "自购分佣",
                align: "center",
                height: "40",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "subRate",
                label: "平台补贴",
                align: "center",
                height: "40",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "directRate",
                label: "直属分佣",
                align: "center",
                height: "40",
              },
            }),
            _vm._v(" "),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "",
                  label: "团队分佣比例配置1",
                  align: "center",
                  height: "40",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "teamRate",
                    label: "团队比例",
                    align: "center",
                    height: "40",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lateralRateList[0].rate",
                    label: "平1级奖励",
                    align: "center",
                    height: "40",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lateralRateList[1].rate",
                    label: "平2级奖励",
                    align: "center",
                    height: "40",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lateralRateList[2].rate",
                    label: "平3级奖励",
                    align: "center",
                    height: "40",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "",
                  label: "团队分佣比例配置2",
                  align: "center",
                  height: "40",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "teamPlusRate",
                    label: "团队比例",
                    align: "center",
                    height: "40",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lateralPlusRateList[0].rate",
                    label: "平1级奖励",
                    align: "center",
                    height: "40",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lateralPlusRateList[1].rate",
                    label: "平2级奖励",
                    align: "center",
                    height: "40",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lateralPlusRateList[2].rate",
                    label: "平3级奖励",
                    align: "center",
                    height: "40",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "createTime",
                label: "创建时间",
                align: "center",
                height: "40",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "status",
                label: "状态",
                align: "center",
                height: "40",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.status === 1
                        ? _c("div", [_vm._v("禁用")])
                        : _vm._e(),
                      _vm._v(" "),
                      scope.row.status === 0
                        ? _c("div", [_vm._v("正常")])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "name",
                label: "操作",
                align: "center",
                width: "200",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _c("img", {
                          staticClass: "icon_box pointer handle",
                          attrs: {
                            src: require("@/assets/icon/mark1.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "icon_box ml20 pointer",
                          attrs: {
                            src: require("@/assets/personnelManage/editor.png"),
                            alt: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onEditor(scope.row)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "icon_box ml20 pointer",
                          attrs: {
                            src: require("@/assets/personnelManage/delete.png"),
                            alt: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onDelete(scope.row)
                            },
                          },
                        }),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-dialog",
          {
            attrs: {
              "close-on-click-modal": false,
              visible: _vm.dialogVisible,
              width: "1000px",
            },
            on: { close: _vm.close },
          },
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  "status-icon": "",
                  rules: _vm.rules,
                  "label-width": "150px",
                },
              },
              [
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "bock_box" }, [
                    _c("div", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [_vm._v("等级状态")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex ml20",
                      staticStyle: {
                        color: "#f59a23",
                        "font-size": "12px",
                        "line-height": "24px",
                      },
                    },
                    [
                      _vm._v(
                        "\n            当前等级存在用户时，无法选择禁用\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": _vm.marginWidth,
                          label: "选择等级状态:",
                          prop: "status",
                        },
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 0 },
                            model: {
                              value: _vm.ruleForm.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "status", $$v)
                              },
                              expression: "ruleForm.status",
                            },
                          },
                          [_vm._v("启用")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 1 },
                            model: {
                              value: _vm.ruleForm.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "status", $$v)
                              },
                              expression: "ruleForm.status",
                            },
                          },
                          [_vm._v("禁用")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "bock_box" }, [
                    _c("div", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [_vm._v("基础配置")]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "mt30",
                    attrs: {
                      "label-width": _vm.marginWidth,
                      label: "等级名称:",
                      prop: "name",
                    },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.ruleForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "name", _vm._n($$v))
                        },
                        expression: "ruleForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "mt30",
                    attrs: {
                      label: "等级权重:",
                      "label-width": _vm.marginWidth,
                      prop: "grade",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "number" },
                      on: { change: _vm.onChangeGrade },
                      model: {
                        value: _vm.ruleForm.grade,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "grade", _vm._n($$v))
                        },
                        expression: "ruleForm.grade",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "acquiesce_tips" }, [
                      _vm._v(
                        '\n            注：输入 "数字"\n            设置等级权重，数字越大，权重越高（已创建的等级权重无法重复创建）\n          '
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "mt30",
                    attrs: {
                      "label-width": _vm.marginWidth,
                      label: "等级图标:",
                      prop: "icon",
                    },
                  },
                  [
                    _c("div", { staticClass: "upload_box flex" }, [
                      _c("div", { staticClass: "img" }, [
                        _c(
                          "div",
                          { staticStyle: { border: "1px dashed #cacaca" } },
                          [
                            _vm.ruleForm.icon
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%",
                                  },
                                  attrs: {
                                    "preview-src-list": [_vm.ruleForm.icon],
                                    src: _vm.ruleForm.icon,
                                    fit: "scale-down",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "fc acquiesce_tips" }, [
                          _vm._v(
                            "\n                建议尺寸147×36,PNG格式\n              "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "upload_btn fc ml10" },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "http-request": _vm.onRequest,
                                "show-file-list": false,
                                action: "",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { size: "medium", type: "primary" } },
                                [_vm._v("点击上传")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "bock_box" }, [
                    _c("div", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v("\n              用户升级权限\n              "),
                      _c(
                        "span",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "font-size": "14px",
                            color: "#f59a23",
                            "font-weight": "400",
                          },
                        },
                        [_vm._v("是否允许当前等级用户自助升级到下一个等级")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "用户升级权限选择:",
                          "label-width": _vm.marginWidth,
                          prop: "selfUpgrade",
                        },
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 1 },
                            model: {
                              value: _vm.ruleForm.selfUpgrade,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "selfUpgrade", $$v)
                              },
                              expression: "ruleForm.selfUpgrade",
                            },
                          },
                          [_vm._v("允许用户自助升级")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 0 },
                            on: { input: _vm.onProhibitedUpgrade },
                            model: {
                              value: _vm.ruleForm.selfUpgrade,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "selfUpgrade", $$v)
                              },
                              expression: "ruleForm.selfUpgrade",
                            },
                          },
                          [_vm._v("禁止用户自助升级")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "acquiesce_tips" }, [
                          _vm._v(
                            '选择"禁止用户自助升级"时，会隐藏App内的“升级中心”入口，当前等级用户无法自行升级 (仅支持后台修改用户等级)'
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.ruleForm.selfUpgrade === 1
                  ? _c(
                      "div",
                      { staticStyle: { "margin-top": "20px" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "选择升级方式:",
                              "label-width": _vm.marginWidth,
                              prop: "upgradeMethod",
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: 0 },
                                model: {
                                  value: _vm.ruleForm.upgradeMethod,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "upgradeMethod", $$v)
                                  },
                                  expression: "ruleForm.upgradeMethod",
                                },
                              },
                              [_vm._v("默认升级")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-radio",
                              {
                                attrs: { label: 1 },
                                model: {
                                  value: _vm.ruleForm.upgradeMethod,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "upgradeMethod", $$v)
                                  },
                                  expression: "ruleForm.upgradeMethod",
                                },
                              },
                              [_vm._v("自定义升级")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "acquiesce_tips" }, [
                              _vm._v(
                                '选择"默认升级"，用户升级时会自动升级至下一权重等级；选择“自定义”时，可在更高权重等级内选择升级对象。'
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.ruleForm.upgradeMethod === 1
                  ? _c(
                      "div",
                      { staticStyle: { "margin-top": "20px" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "选择升级至哪一等级:",
                              "label-width": _vm.marginWidth,
                              prop: "targetGrade",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "600px" },
                                attrs: {
                                  "no-data-text":
                                    "暂无可升级等级（请先创建权重更高的等级）",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.ruleForm.targetGrade,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "targetGrade", $$v)
                                  },
                                  expression: "ruleForm.targetGrade",
                                },
                              },
                              _vm._l(_vm.editOptions, function (item) {
                                return _c("el-option", {
                                  key: item.grade,
                                  attrs: {
                                    label: item.name,
                                    value: item.grade,
                                  },
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "acquiesce_tips" }, [
                              _vm._v(
                                " 选择当前等级可升级至哪一等级，注意，不可选择比当前权重更低的等级！"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "bock_box" }, [
                    _c("div", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v("\n              升级配置\n              "),
                      _c(
                        "span",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "font-size": "14px",
                            color: "#f59a23",
                            "font-weight": "400",
                          },
                        },
                        [_vm._v("配置低等级升级到当前等级的条件")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "mt30",
                    attrs: {
                      "label-width": _vm.marginWidth,
                      label: "等级权益图:",
                      prop: "benefitImage",
                    },
                  },
                  [
                    _c("div", { staticClass: "upload_box flex" }, [
                      _c(
                        "div",
                        {
                          staticClass: "img",
                          staticStyle: { width: "170px", height: "80px" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "170px",
                                height: "80px",
                                border: "1px dashed #cacaca",
                              },
                            },
                            [
                              _vm.ruleForm.benefitImage
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                      display: "flex",
                                      "align-items": "center",
                                      border: "none!important",
                                    },
                                    attrs: {
                                      "preview-src-list": [
                                        _vm.ruleForm.benefitImage,
                                      ],
                                      src: _vm.ruleForm.benefitImage,
                                      fit: "scale-down",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "upload_btn1 fc ml10" },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "http-request": _vm.onRequest1,
                                "show-file-list": false,
                                action: "",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { size: "medium", type: "primary" } },
                                [_vm._v("点击上传")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "acquiesce_tips" }, [
                      _vm._v(
                        "\n            建议宽度650，高度不限的白色背景图片，以便更好在升级中心展示\n          "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.ruleForm.upgradeModel === 1
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "mt30",
                            attrs: {
                              "label-width": _vm.marginWidth,
                              label: "升级条件说明文字:",
                              prop: "upgradeTips",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                placeholder:
                                  " 请输入，C端升级中心-升级途径上的介绍说明文字",
                              },
                              model: {
                                value: _vm.ruleForm.upgradeTips,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "upgradeTips", $$v)
                                },
                                expression: "ruleForm.upgradeTips",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.ruleForm.upgradeModel === 1
                  ? _c(
                      "div",
                      _vm._l(_vm.ruleForm.conditionList, function (i, k) {
                        return _c(
                          "div",
                          { key: k },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0px" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex" },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          "true-label": 1,
                                          "false-label": 0,
                                        },
                                        model: {
                                          value: i.enable,
                                          callback: function ($$v) {
                                            _vm.$set(i, "enable", $$v)
                                          },
                                          expression: "i.enable",
                                        },
                                      },
                                      [_vm._v("升级途径" + _vm._s(k + 1) + ":")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "fc" }, [
                                      _c(
                                        "div",
                                        { staticClass: "flex" },
                                        _vm._l(
                                          _vm.conditionsListData,
                                          function (item) {
                                            return _c(
                                              "div",
                                              {
                                                key: item.id,
                                                staticClass: "fc",
                                                staticStyle: {
                                                  height: "24px",
                                                  margin: "0px 2px",
                                                  padding: "0px 5px",
                                                  color: "#fff",
                                                  "font-size": "14px",
                                                  cursor: "pointer",
                                                  "border-radius": "4px",
                                                },
                                                style: {
                                                  background: item.color,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onAddConditions(
                                                      k,
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.name) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "ml20" },
                                      [
                                        i.enable
                                          ? _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  "label-width": "0px",
                                                  prop:
                                                    "conditionList." +
                                                    k +
                                                    ".model",
                                                  rules: _vm.modelRules,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    条件模式:\n                    "
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-radio",
                                                  {
                                                    attrs: {
                                                      label: 0,
                                                      disabled:
                                                        _vm
                                                          .conditionTrueIsNoList[
                                                          i.index
                                                        ],
                                                    },
                                                    model: {
                                                      value: i.model,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          i,
                                                          "model",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "i.model",
                                                    },
                                                  },
                                                  [_vm._v("同时满足")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-radio",
                                                  {
                                                    attrs: { label: 1 },
                                                    model: {
                                                      value: i.model,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          i,
                                                          "model",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "i.model",
                                                    },
                                                  },
                                                  [_vm._v("任意条件")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    i.enable
                                      ? _c(
                                          "div",
                                          { staticClass: "ml30" },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content",
                                                  },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                        【任意满足】：只要会员满足所选途径内的其中一个条件就可以升级。\n                      "
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                        【同时满足】：设置的升级条件必须同时满足才可以升级。如果设置的有充值和其他条件同时满足，会员必须先满足条件再去付费升级。\n                      "
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                        注意：单一途径内设置超过两条充值条件时，无法设置为同时满足。\n                      "
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "12px",
                                                    height: "12px",
                                                  },
                                                  attrs: {
                                                    src: require("@/assets/warning_reminder.png"),
                                                    alt: "",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt20" }, [
                                  _c(
                                    "div",
                                    { staticStyle: { width: "100%" } },
                                    _vm._l(i.termList, function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticStyle: { width: "100%" },
                                        },
                                        [
                                          _c("div", { staticClass: "flex" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mb10 scalation_Condition flex fc",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "fc checkbox",
                                                    staticStyle: {
                                                      width: "100px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.UnitType[
                                                            item.type
                                                          ].title
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                item.type !== 4
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "180px",
                                                        },
                                                        attrs: {
                                                          "popper-class":
                                                            "select",
                                                          placeholder:
                                                            "请选择时间",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value: item.time,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "time",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.time",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.selectData[
                                                          _vm.UnitType[
                                                            item.type
                                                          ].selectDataName
                                                        ].timeLimit,
                                                        function (i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i.key,
                                                              attrs: {
                                                                label: i.value,
                                                                value: i.key,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.type === 1
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "180px",
                                                        },
                                                        attrs: {
                                                          "popper-class":
                                                            "select",
                                                          placeholder:
                                                            "选择用户关系",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value: item.rela,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "rela",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.rela",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.selectData[
                                                          _vm.UnitType[
                                                            item.type
                                                          ].selectDataName
                                                        ].relationLimit,
                                                        function (i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i.key,
                                                              attrs: {
                                                                label: i.value,
                                                                value: i.key,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.type === 1
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "180px",
                                                        },
                                                        attrs: {
                                                          "popper-class":
                                                            "select",
                                                          placeholder:
                                                            "选择用户类型",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value: item.item,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "item",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.item",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.selectData[
                                                          _vm.UnitType[
                                                            item.type
                                                          ].selectDataName
                                                        ].itemLimit,
                                                        function (i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i.key,
                                                              attrs: {
                                                                label: i.value,
                                                                value: i.key,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.type === 2
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "180px",
                                                        },
                                                        attrs: {
                                                          "popper-class":
                                                            "select",
                                                          placeholder:
                                                            "选择订单类型",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value: item.item,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "item",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.item",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.selectData[
                                                          _vm.UnitType[
                                                            item.type
                                                          ].selectDataName
                                                        ].itemLimit,
                                                        function (i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i.key,
                                                              attrs: {
                                                                label: i.value,
                                                                value: i.key,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.type === 3
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "180px",
                                                        },
                                                        attrs: {
                                                          "popper-class":
                                                            "select",
                                                          placeholder:
                                                            "选择收益归属",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value: item.rela,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "rela",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.rela",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.selectData[
                                                          _vm.UnitType[
                                                            item.type
                                                          ].selectDataName
                                                        ].relationLimit,
                                                        function (i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i.key,
                                                              attrs: {
                                                                label: i.value,
                                                                value: i.key,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.type === 3
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "180px",
                                                        },
                                                        attrs: {
                                                          "popper-class":
                                                            "select",
                                                          placeholder:
                                                            "选择收益类型",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value: item.item,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "item",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.item",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.selectData[
                                                          _vm.UnitType[
                                                            item.type
                                                          ].selectDataName
                                                        ].itemLimit,
                                                        function (i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i.key,
                                                              attrs: {
                                                                label: i.value,
                                                                value: i.key,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.type === 4
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "180px",
                                                        },
                                                        attrs: {
                                                          "popper-class":
                                                            "select",
                                                          placeholder:
                                                            "充值类型",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value: item.item,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "item",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.item",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.selectData[
                                                          _vm.UnitType[
                                                            item.type
                                                          ].selectDataName
                                                        ].itemLimit,
                                                        function (i) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: i.key,
                                                              attrs: {
                                                                label: i.value,
                                                                value: i.key,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "el-input",
                                                  {
                                                    staticStyle: {
                                                      height: "38px",
                                                    },
                                                    style: {
                                                      width:
                                                        _vm.UnitType[item.type]
                                                          .dimension,
                                                    },
                                                    attrs: {
                                                      max: 100,
                                                      min: 0,
                                                      type: "number",
                                                      placeholder: "请输入内容",
                                                    },
                                                    model: {
                                                      value: item.value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.value",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      {
                                                        staticStyle: {
                                                          height: "38px",
                                                          background: "#cacaca",
                                                        },
                                                        slot: "append",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.UnitType[
                                                              item.type
                                                            ].unit
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "fc" }, [
                                              _c("img", {
                                                staticClass:
                                                  "icon_box ml20 pointer",
                                                attrs: {
                                                  src: require("@/assets/personnelManage/delete.png"),
                                                  alt: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDeleteConditions(
                                                      k,
                                                      index
                                                    )
                                                  },
                                                },
                                              }),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "bock_box" }, [
                    _c("div", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v("\n              自购分佣配置\n              "),
                      _c(
                        "span",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "font-size": "14px",
                            color: "#f59a23",
                            "font-weight": "400",
                          },
                        },
                        [_vm._v("以下条件设置为0则不启用")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "mt30",
                    attrs: {
                      "label-width": _vm.marginWidth,
                      label: "自购分佣:",
                      prop: "selfRate",
                    },
                  },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { type: "number", placeholder: "请输入内容" },
                        model: {
                          value: _vm.ruleForm.selfRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "selfRate", $$v)
                          },
                          expression: "ruleForm.selfRate",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "acquiesce_tips" }, [
                      _vm._v(
                        "\n            自购/分享分佣为扣除联盟服务费用后，用户自购下单拿到的佣金百分比\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isExceed,
                            expression: "isExceed",
                          },
                        ],
                        staticClass: "title_tips",
                      },
                      [
                        _vm._v(
                          "\n            佣金百分比不能超过100\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "bock_box" }, [
                    _c("div", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v("\n              平台补贴配置\n              "),
                      _c(
                        "span",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "font-size": "14px",
                            color: "#f59a23",
                            "font-weight": "400",
                          },
                        },
                        [_vm._v("以下条件设置为0则不启用")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "mt30",
                    attrs: {
                      "label-width": _vm.marginWidth,
                      label: "平台补贴:",
                      prop: "subRate",
                    },
                  },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { type: "number", placeholder: "请输入内容" },
                        model: {
                          value: _vm.ruleForm.subRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "subRate", $$v)
                          },
                          expression: "ruleForm.subRate",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "acquiesce_tips" }, [
                      _vm._v(
                        "\n            基于商品佣金，平台额外补贴给用户的比例\n          "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "bock_box" }, [
                    _c("div", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(
                        "\n              直属上级分佣配置\n              "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "font-size": "14px",
                            color: "#f59a23",
                            "font-weight": "400",
                          },
                        },
                        [_vm._v("以下条件设置为0则不启用")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "mt30",
                    attrs: {
                      "label-width": _vm.marginWidth,
                      label: "直属分佣:",
                      prop: "directRate",
                    },
                  },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { type: "number", placeholder: "请输入内容" },
                        model: {
                          value: _vm.ruleForm.directRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "directRate", $$v)
                          },
                          expression: "ruleForm.directRate",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "acquiesce_tips" }, [
                      _vm._v("配置直属邀请人的佣金分佣比例"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("div", { staticClass: "bock_box" }, [
                    _c("div", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v("\n              团队分佣配置\n              "),
                      _c(
                        "span",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "font-size": "14px",
                            color: "#f59a23",
                            "font-weight": "400",
                          },
                        },
                        [
                          _vm._v(
                            "在原有商品佣金的基础上，分给用户直属上级的佣金比例"
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "div",
                      { staticClass: "Commission_box" },
                      [
                        _c("div", { staticClass: "title1" }, [
                          _c("div", { staticClass: "bock_box" }, [
                            _c("div", { staticClass: "text" }, [
                              _vm._v(
                                "\n                  团队分佣比例配置1\n                  "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "ml20",
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "#f59a23",
                                    "font-weight": "400",
                                  },
                                },
                                [_vm._v("以下条件设置为0则不启用")]
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-divider"),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "mt20",
                            attrs: {
                              "label-width": _vm.marginWidth1,
                              label: "团队比例:",
                              prop: "teamRate",
                            },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入内容",
                                },
                                model: {
                                  value: _vm.ruleForm.teamRate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "teamRate", $$v)
                                  },
                                  expression: "ruleForm.teamRate",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.ruleForm.lateralRateList, function (i, k) {
                          return _c(
                            "el-form-item",
                            {
                              key: k,
                              attrs: {
                                "label-width": _vm.marginWidth1,
                                prop: "lateralRateList",
                                label: "平" + i.order + "级奖励:",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { type: "number", placeholder: "" },
                                  model: {
                                    value: i.rate,
                                    callback: function ($$v) {
                                      _vm.$set(i, "rate", $$v)
                                    },
                                    expression: "i.rate",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "Commission_box " },
                      [
                        _c("div", { staticClass: "title1" }, [
                          _c("div", { staticClass: "bock_box" }, [
                            _c("div", { staticClass: "text" }, [
                              _vm._v(
                                "\n                  团队分佣比例配置2\n                  "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "ml20",
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "#f59a23",
                                    "font-weight": "400",
                                  },
                                },
                                [_vm._v("以下升级条件，设置为0则不启用")]
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-divider"),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "mt20",
                            attrs: {
                              "label-width": _vm.marginWidth1,
                              label: "团队比例:",
                              prop: "teamPlusRate",
                            },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入内容",
                                },
                                model: {
                                  value: _vm.ruleForm.teamPlusRate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "teamPlusRate", $$v)
                                  },
                                  expression: "ruleForm.teamPlusRate",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.ruleForm.lateralPlusRateList, function (i) {
                          return _c(
                            "el-form-item",
                            {
                              key: i.id,
                              attrs: {
                                "label-width": _vm.marginWidth1,
                                label: "平" + i.order + "级奖励:",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { type: "number", placeholder: "" },
                                  model: {
                                    value: i.rate,
                                    callback: function ($$v) {
                                      _vm.$set(i, "rate", $$v)
                                    },
                                    expression: "i.rate",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "mt30",
                        attrs: {
                          "label-width": _vm.marginWidth,
                          label: "选择分佣模式:",
                          prop: "plusModel",
                        },
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 0 },
                            model: {
                              value: _vm.ruleForm.plusModel,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "plusModel", $$v)
                              },
                              expression: "ruleForm.plusModel",
                            },
                          },
                          [_vm._v("团队分佣比例配置1")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 1 },
                            model: {
                              value: _vm.ruleForm.plusModel,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "plusModel", $$v)
                              },
                              expression: "ruleForm.plusModel",
                            },
                          },
                          [_vm._v("团队分佣比例配置2")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": _vm.marginWidth,
                          label: "团队分佣模式:",
                          prop: "teamShare",
                        },
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 0 },
                            model: {
                              value: _vm.ruleForm.teamShare,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "teamShare", $$v)
                              },
                              expression: "ruleForm.teamShare",
                            },
                          },
                          [_vm._v("禁止团队分佣")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 1 },
                            model: {
                              value: _vm.ruleForm.teamShare,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "teamShare", $$v)
                              },
                              expression: "ruleForm.teamShare",
                            },
                          },
                          [_vm._v("启用团队分佣")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fc" },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "172px",
                      height: "52px",
                      background: "#4d8aff",
                      "border-radius": "4px",
                    },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitForm("ruleForm")
                      },
                    },
                  },
                  [_vm._v("确认")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: { visible: _vm.delDialogVisible, width: "400px" },
            on: {
              "update:visible": function ($event) {
                _vm.delDialogVisible = $event
              },
              close: _vm.delClose,
            },
          },
          [
            _c("div", [_vm._v("会员等级状态是启用情况下，不可直接删除")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fc mt30" },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "172px",
                      height: "52px",
                      background: "#4d8aff",
                      "border-radius": "4px",
                    },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.delDialogVisible = false
                      },
                    },
                  },
                  [_vm._v("确认")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [
        _vm._v(
          "温馨提示：只可以删除禁用状态且无会员的等级；相同权重等级之间仅支持一个处于启用状态。"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }